import Lottie from 'react-lottie';
import LoadingAnimation from 'assets/lottie/loading-vertical-lines.json';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import useBankIDWaiting from './useBankIDWaiting';

const LottieOptions = {
  loop: true,
  autoplay: true,
  animationData: LoadingAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const BankIdWaiting = () => {
  const { t } = useTranslation();

  useBankIDWaiting();

  return (
    <>
      <Helmet>
        <title>{t('waiting:html_title')}</title>
      </Helmet>

      <div className="pointer-events-none" data-test="waiting-lottie-bank-id">
        <Lottie width={350} options={LottieOptions} isClickToPauseDisabled />
      </div>

      <h1
        className="text-center text-4xl font-semibold mb-6"
        data-test="waiting-title"
      >
        {t('waiting:title')}
      </h1>
      <p className="text-center max-w-[420px] mx-auto" data-test="waiting-info">
        {t('waiting:info')}
      </p>
    </>
  );
};

export default BankIdWaiting;
